import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tidy-checkbox-button',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./checkbox-button.component.scss'],
  template: `
    <button
      mat-raised-button
      [ngClass]="{'checked': checked}"
      (click)="checkUncheck()"
    >
      <tidy-row [align]="'center'">
        <tidy-text
          class="'white'"
          [actionBody]="label">
        </tidy-text>
      </tidy-row>
    </button>
    `
})
export class CheckboxButtonComponent {

  @Input() label: string;
  @Input() value: string;
  @Input() checked = false;
  @Output() checkedChange = new EventEmitter<boolean>();

  checkUncheck() {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }
}
